/* Base Layout
Author: Maxwell Levene @maxlevene920- Ellmarr
Date: 04/30/2025
Description: Utility functions for user-related operations. Provides helper methods
for data transformation, validation, and common user-related calculations.
*/

// Calculate CO2 offset for a user
export const calculateUserCO2Offset = (distanceKm: number): number => {
  // Using UK DEFRA conversion factor: 0.16272 kg CO2e per km
  return Number((distanceKm * 0.16272).toFixed(2));
};

// Call the get_user_distances function for a user
export const getUserDistances = async () => {
  const { supabase } = await import('@/integrations/supabase/client');
  
  try {
    const { data, error } = await supabase.rpc('get_user_distances');
    
    if (error) {
      console.error("Error fetching user distances:", error);
      throw error;
    }
    
    console.log("User distances data:", data);
    
    // The get_user_distances function returns a single-row table
    // We need to access the first element of the array
    return {
      totalDistance: data?.[0]?.distance_traveled || 0,
      offsetDistance: data?.[0]?.distance_offset || 0
    };
  } catch (error) {
    console.error("Error in getUserDistances:", error);
    return {
      totalDistance: 0,
      offsetDistance: 0
    };
  }
};
